// Storage keys are spelled out here, not read from GHD.KEYS
// (dashboard/js/storage-keys.js): this file runs first in <head>, before any
// namespace exists. GHD.KEYS is still the registry of record —
// every key below is listed there, so keep the two in step.
//
// Share this page's locale with the dashboard SPA so signing in from a localized page
// keeps the language. The SPA reads localStorage 'ghd_ui_lang' on load, and
// localStorage is per-origin — the app has its own — so the value reaches it only
// through the /go/ hop.
// A link straight to the app carries the locale in its URL instead: build time stamps
// ?lang= on every one a localized page holds (tools/lib/i18n_common.stamp_app_locale)
// and dashboard/i18n/arrival-locale.js adopts it there under exactly the rules below.
//
// Only a *landing-derived* value may be overwritten. A locale someone deliberately
// chose (the settings picker, the share pages' header picker, or reconciling the
// account's saved preference — see dashboard/js/i18n.js and js/public-i18n.js)
// outranks whichever page the user happens to open, so a Dutch
// account bouncing off the English homepage no longer boots the dashboard in English
// and then has to switch back. 'ghd_ui_lang_seed' records who wrote the language last:
// this file writes the locale it seeded, a deliberate pick writes the sentinel "app".
// Still equal
// to our own seed means nobody has expressed a stronger preference since, so the
// language picker (plain links to /nl/, /de/, …) can still move the SPA's language. A
// missing seed means the value predates this key and is treated as landing-derived —
// the old behaviour, self-correcting after one visit.
try {
  // The code, not the tag: a page can be `lang="zh-Hant"` for locale `zh`.
  var l = (document.documentElement.lang || "").split("-")[0];
  if (
    ["en", "nl", "de", "es", "fr", "pt", "it", "hu", "ru", "pl", "id", "tr", "ca", "uk", "el", "cs", "sv", "nb", "ro", "fi", "th", "vi", "bg", "da", "ja", "ko", "zh"].indexOf(l) !== -1
  ) {
    var storedLang = localStorage.getItem("ghd_ui_lang");
    var seededLang = localStorage.getItem("ghd_ui_lang_seed");
    if (!storedLang || seededLang === null || storedLang === seededLang) {
      localStorage.setItem("ghd_ui_lang", l);
      localStorage.setItem("ghd_ui_lang_seed", l);
    }
  }
} catch (e) {}
// Capture the Google Ads click id (auto-tagging appends ?gclid= to paid landings).
// The dashboard SPA (same origin) sends it to the backend at signup for offline
// conversion uploads. 90 days matches Google's click attribution window.
try {
  var g = new URLSearchParams(location.search).get("gclid");
  if (g) localStorage.setItem("ghd_gclid", JSON.stringify({ v: g, t: Date.now() }));
} catch (e) {}
